module.exports = __webpack_public_path__ + "static/media/poketrader-small.8eb9208b.png";